
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as signinawKlupfeildDdXrIM2LPmI5jOdsD7WNv6lb6o6QgkAEMeta } from "/app/pages/signin.vue?macro=true";
import { default as verifyl1suJ3zT7AL2RaLcTuuojB_8UsVA3kw9L_gPZi3lvLwMeta } from "/app/pages/verify.vue?macro=true";
import { default as actionsSuJL2AL4iEAK_45c90lCtrelZ9B9QHqbH_458gO3WuakoNoMeta } from "/app/pages/actions.vue?macro=true";
import { default as signout8xYhb_wZOAkH2DbUU_KiJ5KWOGY_45W9UOupv9zxgDHjkMeta } from "/app/pages/signout.vue?macro=true";
import { default as testsKCWroYa_QYF7EY7Ekdy92PwAfTAuV_45K7FrJY3ynmkIMeta } from "/app/pages/test/test.vue?macro=true";
import { default as metaMXIEuepEOpx_FGgKWiIza5ySnKkh8x_JaiwWBKrOV5sMeta } from "/app/pages/admin/meta.vue?macro=true";
import { default as index_45YqZdB_VzlZy8_45sj5tCG87p_fqHr5B_455V1EEKSka25kMeta } from "/app/pages/journal/index.vue?macro=true";
import { default as reset_45passwordiWFFQc4mqHAplbYzhpvNKouyr6Qp9Bvu_45FM1ScN8_pgMeta } from "/app/pages/reset-password.vue?macro=true";
import { default as indexZyZ3PZ9kTf2x7hlg_45ed893AcXTdXPdJnQzdIzlmSmqEMeta } from "/app/pages/roles/menu/index.vue?macro=true";
import { default as newe38uyM1ypY_45R3w7bFtlQOUiUvnPaexGfZb_lKvPgYVEMeta } from "/app/pages/table/[table]/new.vue?macro=true";
import { default as _91batch_no_93kHATd4CSQutA_45v5_Wt1G_45A2jC1_451AA5OFAqmpVhd1JQMeta } from "/app/pages/journal/[batch_no].vue?macro=true";
import { default as _91id_93_4501yDue3mzu_45LXHORscSkkTuwHX84hkYfVBMbnRzl6QMeta } from "/app/pages/table/[table]/[id].vue?macro=true";
import { default as index4dS53hM0Q9OURqqhIvLVX6qvl_aK0HDZij3qQX9WnlAMeta } from "/app/pages/table/[table]/index.vue?macro=true";
import { default as forgot_45passwordCSWbKn9J3J_B220JzyKrtw7YYrymJGKEwS0HPhIK87AMeta } from "/app/pages/auth/forgot-password.vue?macro=true";
import { default as indexFkNeSozT_45Vmq8o2mQIGzOECX1xVVbCX_rfY2GrEX0JIMeta } from "/app/pages/bulktable/[table]/index.vue?macro=true";
import { default as indexGhhpoo_45eRPGvAb6doP_4529NERd4pwy21leD02bJpHM5MMeta } from "/app/pages/actiontable/[table]/index.vue?macro=true";
import { default as index9TYHtluKYaFCM7RTXlhXc5B4_uU_KTpB0_45gbfNL2vy8Meta } from "/app/pages/table/GroupSettings/index.vue?macro=true";
import { default as indexkvi3pgGXRM8MQaAEAaL81swU25268eP8vbXZDWSmjMIMeta } from "/app/pages/internal/[menugroup]/index.vue?macro=true";
import { default as forgot_45password_45success5QV_45LYZsyL_45nAUkdvNnLYKcGOAQXfjtEBM_2PMyy7s4Meta } from "/app/pages/auth/forgot-password-success.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "signin",
    path: "/signin",
    meta: signinawKlupfeildDdXrIM2LPmI5jOdsD7WNv6lb6o6QgkAEMeta || {},
    component: () => import("/app/pages/signin.vue")
  },
  {
    name: "verify",
    path: "/verify",
    meta: verifyl1suJ3zT7AL2RaLcTuuojB_8UsVA3kw9L_gPZi3lvLwMeta || {},
    component: () => import("/app/pages/verify.vue")
  },
  {
    name: "actions",
    path: "/actions",
    component: () => import("/app/pages/actions.vue")
  },
  {
    name: "signout",
    path: "/signout",
    meta: signout8xYhb_wZOAkH2DbUU_KiJ5KWOGY_45W9UOupv9zxgDHjkMeta || {},
    component: () => import("/app/pages/signout.vue")
  },
  {
    name: "test-test",
    path: "/test/test",
    component: () => import("/app/pages/test/test.vue")
  },
  {
    name: "admin-meta",
    path: "/admin/meta",
    component: () => import("/app/pages/admin/meta.vue")
  },
  {
    name: "journal",
    path: "/journal",
    component: () => import("/app/pages/journal/index.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordiWFFQc4mqHAplbYzhpvNKouyr6Qp9Bvu_45FM1ScN8_pgMeta || {},
    component: () => import("/app/pages/reset-password.vue")
  },
  {
    name: "roles-menu",
    path: "/roles/menu",
    component: () => import("/app/pages/roles/menu/index.vue")
  },
  {
    name: "table-table-new",
    path: "/table/:table()/new",
    component: () => import("/app/pages/table/[table]/new.vue")
  },
  {
    name: "journal-batch_no",
    path: "/journal/:batch_no()",
    component: () => import("/app/pages/journal/[batch_no].vue")
  },
  {
    name: "table-table-id",
    path: "/table/:table()/:id()",
    component: () => import("/app/pages/table/[table]/[id].vue")
  },
  {
    name: "table-table",
    path: "/table/:table()",
    component: () => import("/app/pages/table/[table]/index.vue")
  },
  {
    name: "auth-forgot-password",
    path: "/auth/forgot-password",
    meta: forgot_45passwordCSWbKn9J3J_B220JzyKrtw7YYrymJGKEwS0HPhIK87AMeta || {},
    component: () => import("/app/pages/auth/forgot-password.vue")
  },
  {
    name: "bulktable-table",
    path: "/bulktable/:table()",
    component: () => import("/app/pages/bulktable/[table]/index.vue")
  },
  {
    name: "actiontable-table",
    path: "/actiontable/:table()",
    component: () => import("/app/pages/actiontable/[table]/index.vue")
  },
  {
    name: "table-GroupSettings",
    path: "/table/GroupSettings",
    component: () => import("/app/pages/table/GroupSettings/index.vue")
  },
  {
    name: "internal-menugroup",
    path: "/internal/:menugroup()",
    component: () => import("/app/pages/internal/[menugroup]/index.vue")
  },
  {
    name: "auth-forgot-password-success",
    path: "/auth/forgot-password-success",
    meta: forgot_45password_45success5QV_45LYZsyL_45nAUkdvNnLYKcGOAQXfjtEBM_2PMyy7s4Meta || {},
    component: () => import("/app/pages/auth/forgot-password-success.vue")
  }
]